module.exports = {
    privacy: 'Privacy',
    account: 'Account',
    deleteAccount: 'Delete account',
    deleteMessage:
        'To delete your account, enter your password and click save.',
    password: 'Password',
}
